module.exports = __webpack_public_path__ + "static/assets/2a7c73c010bf5fb6c7cd1021dfb8f39a.gif";